import { optionCategory_General } from './category.locstring.json';
import accessibilitySubCategory from './accessibilitySubCategory';
import accountSubCategory from './accountSubCategory';
import appearanceSubCategory from './appearanceSubCategory';
import advertisingSubCategory from './advertisingSubCategory';
import gdpradv2SubCategory from './gdpradv2SubCategory';
import categoriesSubCategory from './categoriesSubCategory';
import privacySubCategory from './privacySubCategory';
import mobileSubCategory from './mobileSubCategory';
import distributionGroupsSubCategory from './distributionGroupsSubCategory';
import notificationsSubCategory from './notificationsSubCategory';
import premiumDashboardSubCategory from './premiumDashboardSubCategory';
import searchSubCategory from './searchSubCategory';
import storageSubCategory from './storageSubCategory';
import unifiedMessagingSubCategory from 'owa-voice-mail-option/lib/VoiceMailSubcategory';
import textMessagingSubCategory from 'owa-text-messaging';
import { ActivityFeedOption } from 'owa-activityfeed-option';
import { ControlIcons } from 'owa-control-icons';
import { OptionCategory } from 'owa-options-core';

let generalCategory: OptionCategory = {
    key: 'general',
    titleStringKey: optionCategory_General,
    icon: ControlIcons.Settings,
    subcategories: [
        accountSubCategory,
        appearanceSubCategory,
        notificationsSubCategory,
        categoriesSubCategory,
        accessibilitySubCategory,
        premiumDashboardSubCategory,
        mobileSubCategory,
        ActivityFeedOption,
        distributionGroupsSubCategory,
        storageSubCategory,
        privacySubCategory,
        searchSubCategory,
        advertisingSubCategory,
        gdpradv2SubCategory,
        textMessagingSubCategory,
        unifiedMessagingSubCategory,
    ],
};

export default generalCategory;
